/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const PurchaseRequestStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  request: {
    name: 'ขอสั่งซื้อ',
    color: 'info',
    icon: 'task_alt',
  },
  approve: {
    name: 'อนุมัติสั่งซื้อ',
    color: 'info',
    icon: 'task_alt',
  },
  receive: {
    name: 'รับบางส่วน',
    color: 'info',
    icon: 'task_alt',
  },
  success: {
    name: 'เสร็จสิ้น',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default PurchaseRequestStatus;
